import { queryCompanyGatewayDetail } from '@/services/company';

export default {
  namespace: 'Devices_gateway',

  state: {
    data: {},
  },

  effects: {
    *fetch({ payload }, { call, put }) {
      const { status, data } = yield call(queryCompanyGatewayDetail, payload);

      if (status === 200) {
        yield put({
          type: 'save',
          payload: {
            ...data.data,
          },
        });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        data: payload,
      };
    },
  },
};
